// extracted by mini-css-extract-plugin
module.exports = {"title":"_3uK538","picture":"_1PHdUD","carouselContainer":"PqiQ8a","pictureContainer":"_1ANefA","chooseGiftCardSkinModal":"zPdeST"};